import axios from 'axios';
import { FETCH_USER, KEEP_USER, LOGIN_USER,ADD_TO_CART,REMOVE_FROM_CART } from './types';
const initialState = { 
        key: '', 
        name: '', 
        userId: '', 
        isAuth: false, 
        forceToChangePW: false,
        loginMethod: '',
        cartItems: []
    }

export const fetchUser = () => async dispatch => {
    const res = await axios.get('/api/auth/CurrentUser');
    if (res.data.data === null) {
        dispatch({ type: FETCH_USER, payload: initialState })
    }
    else if (res.data.data != null) {
        dispatch({ type: FETCH_USER, payload: res.data.data });
    }
};

export const loginUser = (username, password) => async dispatch => {
    let res = await axios.post(`/api/member/Authenticate`, { username, password });
    dispatch({ type: LOGIN_USER, payload: res.data });
};

export const keepUser = (userInfo) => async dispatch => {
    dispatch({ type: KEEP_USER, payload: userInfo });
}

export const addToCart = (product) => async dispatch => {
    dispatch( { type: ADD_TO_CART, payload: product })
}

export const removeFromCart  = (productId) => async dispatch => {
    dispatch({ type: REMOVE_FROM_CART,payload: productId });
}